import universe from './universe.json';
import targetBuyer from './target-buyer.json';

export default {
  universe,
  targetBuyer,
};
